import { FiWifi, FiWifiOff, FiAlertCircle, FiAlertTriangle, FiInfo, FiCheckCircle } from 'react-icons/fi'
import { MdPower, MdPowerOff } from 'react-icons/md'

import type { AssetStateSummary } from './types'

interface AssetListItemProps {
  asset: AssetStateSummary
  isSelected: boolean
  onClick: () => void
  onShowDetails?: () => void
  viewMode?: 'list' | 'details'
  style?: React.CSSProperties
}

export const AssetListItem = ({
  asset,
  isSelected,
  onClick,
  onShowDetails,
  viewMode = 'list',
  style,
}: AssetListItemProps) => {
  // Render severity indicator icon
  const renderSeverityIcon = () => {
    const severity = asset.highestSeverity
    const iconSize = 'w-4 h-4'

    switch (severity) {
      case 'critical':
        return <FiAlertCircle className={`${iconSize} text-red-500`} />
      case 'warning':
        return <FiAlertTriangle className={`${iconSize} text-yellow-500`} />
      case 'informational':
        return <FiInfo className={`${iconSize} text-green-500`} />
      default:
        return <FiCheckCircle className={`${iconSize} text-blue-500`} />
    }
  }

  if (viewMode === 'list') {
    return (
      <div
        style={style}
        className={`h-14 px-3 cursor-pointer flex items-center justify-between 
  transition-colors border-b border-base-300  text-black ${
    isSelected ? 'bg-sky-100 text-sky-900 border-l-2 border-l-sky-500 shadow-md' : 'hover:bg-base-200 border-l'
  }`}
        onClick={onClick}
      >
        <div className="flex-1 flex items-center gap-2 min-w-0 ">
          {renderSeverityIcon()}
          <div className="text-sm font-medium truncate">{asset.name}</div>
          {isSelected && onShowDetails && (
            <button
              onClick={(e) => {
                e.stopPropagation()
                onShowDetails()
              }}
              className="btn btn-xs bg-sky-500 text-white hover:bg-sky-600 border-none
  ml-1 hidden md:block"
            >
              Details
            </button>
          )}
        </div>
        <div className="flex items-center gap-1.5">
          {asset.gatewayOn ? (
            <FiWifi className="w-5 h-5 text-blue-500" />
          ) : (
            <FiWifiOff className="w-5 h-5 text-gray-500" />
          )}
          {asset.powerOn ? (
            <MdPower className="w-5 h-5 text-emerald-600" />
          ) : (
            <MdPowerOff className="w-5 h-5 text-gray-500" />
          )}
        </div>
      </div>
    )
  }

  // Details view (cards)
  return (
    <div
      style={style}
      className={`h-[100px] rounded-none card shadow-sm cursor-pointer transition-all ${
        isSelected
          ? 'bg-sky-100 text-sky-900 border-2 border-sky-300 shadow-xl'
          : 'bg-base-200 hover:shadow-md border-b border-t border-gray-300'
      }`}
      onClick={onClick}
    >
      <div className="card-body p-4">
        <h3 className="card-title text-base flex items-center gap-2">
          {renderSeverityIcon()}
          {asset.name}
          {isSelected && onShowDetails && (
            <button
              onClick={(e) => {
                e.stopPropagation()
                onShowDetails()
              }}
              className="btn btn-xs bg-sky-500 text-white hover:bg-sky-600 border-none
  ml-1"
            >
              Details
            </button>
          )}
        </h3>
        <div className="flex gap-2 mt-2">
          {asset.gatewayOn ? (
            <FiWifi className="w-5 h-5 text-green-500" />
          ) : (
            <FiWifiOff className="w-5 h-5 text-gray-400" />
          )}
          {asset.powerOn ? (
            <MdPower className="w-5 h-5 text-emerald-600" />
          ) : (
            <MdPowerOff className="w-5 h-5 text-gray-400" />
          )}
        </div>
      </div>
    </div>
  )
}
